import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Calendar from './App';

ReactDOM.render(
  <React.StrictMode>
    <Calendar />
  </React.StrictMode>,
  document.getElementById('root'),
);
